import { render, staticRenderFns } from "./person_info.vue?vue&type=template&id=2ed33f99&scoped=true&"
import script from "./person_info.vue?vue&type=script&lang=js&"
export * from "./person_info.vue?vue&type=script&lang=js&"
import style0 from "./person_info.vue?vue&type=style&index=0&id=2ed33f99&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed33f99",
  null
  
)

export default component.exports